import React, { useState, useEffect, useRef } from 'react'
// import "../../../node_modules/react-progress-button/react-progress-button.css"
import { useSnackbar } from 'react-simple-snackbar'
import { useLocation, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { initialState } from '../../initialState'
import { getInvoice, updateInvoice } from '../../actions/invoiceActions'
import { getProfilesByUser } from '../../actions/profile'
import { toCommas } from '../../utils/utils'
import styles from './InvoiceDetails.module.css'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import { Container, Grid, TextField, Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Divider from '@material-ui/core/Divider';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import Spinner from '../Spinner/Spinner'
import {Checkbox, FormGroup, FormControlLabel} from "@material-ui/core";

import ProgressButton from 'react-progress-button'
import axios from 'axios';
import { saveAs } from 'file-saver';
import Modal from '../Payments/Modal'
import PaymentHistory from './PaymentHistory'
import { fetchPdf } from '../../api'
import useAuthUser from '../../hooks/useAuthUser'

const WALK_UP_FEES = {
  '3rd floor': 8,
  '4th floor': 12,
  '5th floor': 18,
  '6th floor': 22,
}

const getWalkUpFee = (walkUp) => WALK_UP_FEES[walkUp] || 0
const calculateBalance = (totalValue, paidValue) =>
  Number(((Number(totalValue) || 0) - (Number(paidValue) || 0)).toFixed(2))
const formatCurrency = (value) => toCommas((Number(value) || 0), 2)
const totalsReducer = (items = [], deliveryFee = 0, haulAway = false, walkUp = '', invoiceWalkUp = '') => {
  const lineCost = items.reduce((sum, item) => {
    const qty = Number(item?.quantity) || 0
    const cost = Number(item?.unitCost) || 0
    return sum + qty * cost
  }, 0)
  const linePrice = items.reduce((sum, item) => {
    const qty = Number(item?.quantity) || 0
    const price = Number(item?.unitPrice) || 0
    return sum + qty * price
  }, 0)
  const fees =
    (Number(deliveryFee) || 0) +
    (haulAway ? 40 : 0) +
    getWalkUpFee(walkUp || invoiceWalkUp)

  const totalCost = lineCost + fees
  const revenueWithFees = linePrice + fees
  const totalProfit = revenueWithFees - totalCost
  return { lineCost, linePrice, fees, totalCost, totalProfit }
}

const getDisplayTotal = (invoiceData, invoice, total) => {
  if (invoiceData?.total !== undefined && invoiceData?.total !== null) {
    return invoiceData.total
  }
  if (invoice?.total !== undefined && invoice?.total !== null) {
    return invoice.total
  }
  return total
}

const InvoiceDetails = () => {

    const location = useLocation()
    const [invoiceData, setInvoiceData] = useState(initialState)
    const [ rates, setRates] = useState(0.00)
    const [deliveryFee, setDeliveryFee] = useState(0.00);
    const [deliveryFeeOverride, setDeliveryFeeOverride] = useState(false);
    const [salesTax, setSalesTax] = useState(0)
    const [subTotal, setSubTotal] = useState(0)
    const [total, setTotal] = useState(0)
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedRbDate, setSelectedRbDate] = useState(new Date());
    const [ billTo, setBillTo ] = useState(null)
    const [ shipTo, setShipTo ] = useState(null)
    const [ contact, setContact ] = useState(null)
    const [type, setType] = React.useState('')
    const [status, setStatus ] = useState('')
    const [company, setCompany] = useState({})
    const [haulAway, setHaulAway] = useState(false)
    const [walkUp, setWalkUp] = useState('')
    const { id } = useParams()
  const { invoice } = useSelector((state) => state.invoices)
  const { profiles } = useSelector((state) => state.profiles || {})
    const dispatch = useDispatch()
    const history = useHistory()
  const isMobile = useMediaQuery('(max-width:768px)');
  const [sendStatus, setSendStatus] = useState(null)
  const [sendPcStatus, setSendPcStatus] = useState(null)
  const [downloadStatus, setDownloadStatus] = useState(null)
  const [podStatus, setPodStatus] = useState(null)
  const [podPhotos, setPodPhotos] = useState([])
  const [podSignature, setPodSignature] = useState('')
  const [podDamage, setPodDamage] = useState('No')
  const [podAcknowledgedBy, setPodAcknowledgedBy] = useState('')
  const [podItemStatuses, setPodItemStatuses] = useState([])
  const [podPdfFile, setPodPdfFile] = useState(null)
  const podPhotoInputRef = useRef(null)
  const podPdfInputRef = useRef(null)
  const [podPreviewOpen, setPodPreviewOpen] = useState(false)
  const [podResendStatus, setPodResendStatus] = useState('idle')
  const [podBothStatus, setPodBothStatus] = useState('idle')
  const currentPodUrl = invoiceData?.proofOfDeliveryUrl || invoice?.proofOfDeliveryUrl
  const currentPodFileId = invoiceData?.proofOfDeliveryFileId || invoice?.proofOfDeliveryFileId
  const hasPodLink = !!(currentPodUrl || currentPodFileId)
  const podStatusLabel = (() => {
    if (podStatus === 'loading') return 'Sending POD...'
    if (podBothStatus === 'loading') return 'Sending POD + Invoice...'
    if (podResendStatus === 'loading') return 'Resending POD...'
    if (currentPodUrl || currentPodFileId) return 'POD saved'
    return 'No POD on file'
  })()
    // eslint-disable-next-line
    const [openSnackbar, closeSnackbar] = useSnackbar()
    const authData = useAuthUser()
    
    const useStyles = makeStyles((theme) => ({
        root: {
          display: 'flex',
          '& > *': {
            margin: theme.spacing(1),
          },
        },
        large: {
          width: theme.spacing(12),
          height: theme.spacing(12),
        },
        table: {
            minWidth: 650,
        },
    
        headerContainer: {
            // display: 'flex'
            paddingTop: theme.spacing(1),
            paddingLeft: theme.spacing(5),
            paddingRight: theme.spacing(1),
            backgroundColor: '#f2f2f2',
            borderRadius: '10px 10px 0px 0px'
        }
      }));
    

    const classes = useStyles()

    useEffect(() => {
        dispatch(getInvoice(id));
      },[id, dispatch, location]);

      useEffect(() => {
        const userId = authData?.result?._id || authData?.result?.googleId
        if (userId) {
          dispatch(getProfilesByUser({ search: userId }))
        }
      }, [dispatch, authData])

    const lawEmailList = profiles?.emailLawList || ''
    const locationContacts = React.useMemo(() => {
      const ship = invoice?.shipTo || invoiceData?.shipTo
      const shipContacts = Array.isArray(ship?.contacts) ? ship.contacts : []
      const contactList =
        Array.isArray(invoice?.contactList) ? invoice.contactList :
        Array.isArray(invoiceData?.contactList) ? invoiceData.contactList : []
      if (shipContacts.length) return shipContacts
      if (contactList.length) return contactList
      return []
    }, [invoice, invoiceData])

      useEffect(() => {
        if(invoice) {
            //Automatically set the default invoice values as the ones in the invoice to be updated
            setInvoiceData(invoice)
            setRates(invoice.rates)
            setBillTo(invoice.billTo || invoice.client || null)
            setShipTo(invoice.shipTo || null)
            setContact(invoice.contact || null)
            setType(invoice.type)
            setStatus(invoice.status)
            setSelectedDate(invoice.dueDate)
            setSelectedRbDate(invoice.receivedByDate)
            setSalesTax(invoice.salesTax)
            setDeliveryFee(invoice.deliveryFee ?? 0)
            setDeliveryFeeOverride(Boolean(invoice.deliveryFeeOverride))
            setSubTotal(invoice.subTotal)
            setTotal(invoice.total)
            setCompany(invoice?.businessDetails?.data?.data)
            setHaulAway(Boolean(invoice.haulAway))
            setWalkUp(invoice.walkUp || '')
           
        }
    }, [invoice])

    //Get the total amount paid
    let totalAmountReceived = 0
    for(var i = 0; i < invoice?.paymentRecords?.length; i++) {
        totalAmountReceived += Number(invoice?.paymentRecords[i]?.amountPaid)
    }


  const editInvoice = (id) => {
    history.push(`/edit/invoice/${id}`)
  }

  const createAndDownloadPdf = () => {
    setDownloadStatus('loading')
    const walkFee = getWalkUpFee(invoice.walkUp)
    const payload = {
      name: invoice.client?.name,
      store: invoice.client?.store,
      address: invoice.client?.address,
      phone: invoice.client?.cellPhone,
      email: '',
      dueDate: invoice.dueDate,
      receivedByDate: invoice.receivedByDate,
      date: invoice.createdAt,
      invoiceNumber: invoice.invoiceNumber,
      id: invoice.invoiceNumber,
      clientPONumber: invoice.clientPONumber,
      pcInvoiceNumber: invoice.pcInvoiceNumber,
      notes: invoice.notes,
      deliveryFee: invoice.deliveryFee,
      haulAway: invoice.haulAway,
      walkUp: invoice.walkUp,
      walkUpFee: walkFee,
      subTotal: invoice.subTotal,
      total: invoice.total,
      type: invoice.type,
      salesTax: invoice.salesTax,
      items: invoice.items,
      status: invoice.status,
      billTo: invoice.billTo || invoice.client,
      shipTo: invoice.shipTo || invoice.client,
      contact: locationContacts.length ? locationContacts : invoice.contact,
      totalAmountReceived: totalAmountReceived,
      balanceDue: calculateBalance(total, totalAmountReceived),
      link: `${process.env.REACT_APP_URL}/invoice/${invoice._id}`,
      paymentRecords: invoice.paymentRecords,
      logoUrl: invoice?.logoUrl || company?.logo,
    }
    axios.post(`${process.env.REACT_APP_API}/pdfs/create-pdf`, payload, {responseType: 'blob'})
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(pdfBlob);
        //Open the URL on new Window
         const pdfWindow = window.open();
         pdfWindow.location.href = fileURL;  
        // saveAs(pdfBlob, 'invoice.pdf')
      }).then(() =>  setDownloadStatus('success'))
      .catch((err) => {
        console.error(err)
        setDownloadStatus('error')
      })
  }

  //SEND PDF INVOICE VIA EMAIL
  const warehouseEmailList = profiles?.emailWarehouseList || ''

  const sendPdf = (e) => {
    e.preventDefault()
    setSendStatus('loading')
    const walkFee = getWalkUpFee(invoice.walkUp)
    const customerInvoicePayload = {
      name: invoice.client?.name,
      store: invoice.client?.store,
      address: invoice.client?.address,
      phone: invoice.client?.cellPhone,
      email: invoice.client?.email,
      dueDate: invoice.dueDate,
      receivedByDate: invoice.receivedByDate,
      date: invoice.createdAt,
      invoiceNumber: invoice.invoiceNumber,
      clientPONumber: invoice.clientPONumber,
      pcInvoiceNumber: invoice.pcInvoiceNumber,
      notes: invoice.notes,
      deliveryFee: invoice.deliveryFee,
      haulAway: invoice.haulAway,
      walkUp: invoice.walkUp,
      walkUpFee: walkFee,
      subTotal: invoice.subTotal,
      total: invoice.total,
      type: invoice.type,
      salesTax: invoice.salesTax,
      items: invoice.items,
      status: invoice.status,
      billTo: invoice.billTo || invoice.client,
      shipTo: invoice.shipTo || invoice.client,
      contact: locationContacts.length ? locationContacts : invoice.contact,
      totalAmountReceived: totalAmountReceived,
      balanceDue: calculateBalance(total, totalAmountReceived),
      link: `${process.env.REACT_APP_URL}/invoice/${invoice._id}`,
      paymentRecords: invoice.paymentRecords,
      logoUrl: invoice?.logoUrl || company?.logo,
    }
    axios.post(`${process.env.REACT_APP_API}/pdfs/send-pdf`, 
    { invoiceId: invoice._id,
      userId: authData?.result?._id || authData?.result?.googleId,
      userEmail: authData?.result?.email,
      bccList: warehouseEmailList,
      ...customerInvoicePayload,
  })
  // .then(() => console.log("invoice sent successfully"))
  .then(() => setSendStatus('success'))
  .catch((error) => {
    console.log(error)
    setSendStatus('error')
  })
  }

  const sendPcPdf = (e) => {
    e.preventDefault()
    setSendPcStatus('loading')
    const walkFee = getWalkUpFee(invoice.walkUp)
    const adjustedTotal =
      (invoice.items || []).reduce(
        (sum, item) => sum + (Number(item.quantity) || 0) * (Number(item.unitCost) || 0),
        0
      ) +
      (Number(invoice.deliveryFee) || 0) +
      (invoice.haulAway ? 40 : 0) +
      (Number(walkFee) || 0)
    axios.post(`${process.env.REACT_APP_API}/pdfs/send-pc-pdf`, 
    { invoiceId: invoice._id,
      userId: authData?.result?._id || authData?.result?.googleId,
      userEmail: authData?.result?.email,
      name: invoice.client?.name,
      store: invoice.client?.store,
      address: invoice.client?.address,
      phone: invoice.client?.cellPhone,
      email: lawEmailList,
      dueDate: invoice.dueDate,
      receivedByDate: invoice.receivedByDate,
      date: invoice.createdAt,
      invoiceNumber: invoice.invoiceNumber,
      id: invoice.invoiceNumber,
      clientPONumber: invoice.clientPONumber,
      pcInvoiceNumber: invoice.pcInvoiceNumber,
      notes: invoice.notes,
      deliveryFee: invoice.deliveryFee,
      haulAway: invoice.haulAway,
      walkUp: invoice.walkUp,
      walkUpFee: walkFee,
      subTotal: invoice.subTotal,
      total: adjustedTotal,
      type: invoice.type,
      salesTax: invoice.salesTax,
      items: invoice.items,
      status: invoice.status,
      billTo: invoice.billTo || invoice.client,
      shipTo: invoice.shipTo || invoice.client,
      contact: locationContacts.length
        ? locationContacts
        : (Array.isArray(invoice.contactList) && invoice.contactList.length
            ? invoice.contactList
            : invoice.contact),
      totalAmountReceived: totalAmountReceived,
      balanceDue: 0,
      link: `${process.env.REACT_APP_URL}/invoice/${invoice._id}`,
      logoUrl: invoice?.logoUrl || company?.logo,
    })
    .then(() => setSendPcStatus('success'))
    .catch((error) => {
      console.log(error)
      setSendPcStatus('error')
    })
  }

  const compressImage = (file, maxDim = 1600, quality = 0.75) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = (ev) => {
        const img = new Image()
        img.onload = () => {
          const scale = Math.min(1, maxDim / Math.max(img.width, img.height))
          const canvas = document.createElement('canvas')
          canvas.width = img.width * scale
          canvas.height = img.height * scale
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
          resolve(canvas.toDataURL('image/jpeg', quality))
        }
        img.onerror = reject
        img.src = ev.target.result
      }
      reader.onerror = reject
      reader.readAsDataURL(file)
    })

  const handlePodPhotoUpload = async (e) => {
    const files = Array.from(e.target.files || [])
    if (!files.length) return
    try {
      const compressed = await Promise.all(files.map((file) => compressImage(file, 1600, 0.75)))
      setPodPhotos((prev) => [...prev, ...compressed])
    } catch (err) {
      console.error('Error compressing pod photos', err)
    }
  }

  const handleRemovePodPhoto = (index) => {
    setPodPhotos((prev) => prev.filter((_, i) => i !== index))
  }

  const handlePodSignatureUpload = async (e) => {
    const file = e.target.files?.[0]
    if (!file) return
    try {
      const compressed = await compressImage(file, 1200, 0.85)
      setPodSignature(compressed)
    } catch (err) {
      console.error('Error compressing signature', err)
    }
  }

  const handlePodPdfUpload = async (e) => {
    const file = e.target.files?.[0]
    if (!file) return
    if (file.type !== 'application/pdf') {
      alert('Please upload a PDF file.')
      return
    }
    const reader = new FileReader()
    reader.onload = () => {
      setPodPdfFile({ name: file.name, dataUrl: reader.result })
    }
    reader.readAsDataURL(file)
  }

  const removePodPdf = () => {
    setPodPdfFile(null)
    if (podPdfInputRef.current) podPdfInputRef.current.value = null
  }

  useEffect(() => {
    if (invoice?.items?.length) {
      setPodItemStatuses((prev) => {
        if (prev.length === invoice.items.length) return prev
        return invoice.items.map(() => 'COMPLETE')
      })
    }
  }, [invoice])

  const handlePodItemStatusChange = (index, value) => {
    setPodItemStatuses((prev) => {
      const next = [...prev]
      next[index] = value
      return next
    })
  }

  const sendProofOfDelivery = () => {
    setPodStatus('loading')
    const acknowledgedName =
      podAcknowledgedBy ||
      ''
    const hasPdf = !!podPdfFile
    const payload = {
      invoiceId: invoice._id,
      userId: authData?.result?._id || authData?.result?.googleId,
      userEmail: authData?.result?.email,
      bccList: warehouseEmailList,
      email: invoice.client?.email,
      invoiceNumber: invoice.invoiceNumber,
      clientPONumber: invoice.clientPONumber,
      shipTo: invoice.shipTo || invoice.client,
      billTo: invoice.billTo || invoice.client,
      items: (invoice.items || []).map((it, idx) => ({
        ...it,
        podStatus: podItemStatuses[idx] || 'COMPLETE',
      })),
      photos: hasPdf ? [] : podPhotos,
      signature: hasPdf ? null : podSignature,
      damageAcknowledged: hasPdf ? '' : podDamage,
      acknowledgedBy: hasPdf ? '' : acknowledgedName,
      contactName: hasPdf ? '' : acknowledgedName,
      contactPhone: hasPdf ? '' : (locationContacts?.[0]?.phone || contact?.phone || ''),
      contactEmail: hasPdf ? '' : (locationContacts?.[0]?.email || contact?.email || ''),
      haulAway: hasPdf ? undefined : invoice.haulAway,
      walkUp: hasPdf ? undefined : invoice.walkUp,
      walkUpFee: hasPdf ? undefined : getWalkUpFee(invoice.walkUp),
      contacts: hasPdf ? [] : locationContacts,
      pdfAttachment: hasPdf ? { filename: podPdfFile.name, content: podPdfFile.dataUrl } : null,
    }
    axios.post(`${process.env.REACT_APP_API}/pdfs/send-pod`, payload)
      .then((resp) => {
        const data = resp?.data || {};
        if (data.proofOfDeliveryUrl || data.proofOfDeliveryFileId) {
          setInvoiceData((prev) => ({
            ...prev,
            proofOfDeliveryUrl: data.proofOfDeliveryUrl || prev.proofOfDeliveryUrl,
            proofOfDeliveryFileId: data.proofOfDeliveryFileId || prev.proofOfDeliveryFileId,
          }));
        }
        setPodStatus('success')
      })
      .catch((err) => {
        console.error(err)
        setPodStatus('error')
      })
  }

  const resendProofOfDelivery = () => {
    if (!hasPodLink) return;
    setPodResendStatus('loading')
    const payload = {
      invoiceId: invoice._id,
      userId: authData?.result?._id || authData?.result?.googleId,
      userEmail: authData?.result?.email,
      bccList: warehouseEmailList,
      email: invoice.client?.email,
      invoiceNumber: invoice.invoiceNumber,
      clientPONumber: invoice.clientPONumber,
      reuseExistingPod: true,
      proofOfDeliveryUrl: currentPodUrl,
      proofOfDeliveryFileId: currentPodFileId,
    }
    axios.post(`${process.env.REACT_APP_API}/pdfs/send-pod`, payload)
      .then((resp) => {
        const data = resp?.data || {};
        if (data.proofOfDeliveryUrl || data.proofOfDeliveryFileId) {
          setInvoiceData((prev) => ({
            ...prev,
            proofOfDeliveryUrl: data.proofOfDeliveryUrl || prev.proofOfDeliveryUrl,
            proofOfDeliveryFileId: data.proofOfDeliveryFileId || prev.proofOfDeliveryFileId,
          }));
        }
        setPodResendStatus('success')
      })
      .catch((err) => {
        console.error(err)
        setPodResendStatus('error')
      })
  }

  const sendProofOfDeliveryAndInvoice = () => {
    setPodBothStatus('loading')
    const acknowledgedName =
      podAcknowledgedBy ||
      ''
    const hasPdf = !!podPdfFile
    const walkFee = getWalkUpFee(invoice.walkUp)
    const customerInvoicePayload = {
      name: invoice.client?.name,
      store: invoice.client?.store,
      address: invoice.client?.address,
      phone: invoice.client?.cellPhone,
      email: invoice.client?.email,
      dueDate: invoice.dueDate,
      receivedByDate: invoice.receivedByDate,
      date: invoice.createdAt,
      invoiceNumber: invoice.invoiceNumber,
      clientPONumber: invoice.clientPONumber,
      pcInvoiceNumber: invoice.pcInvoiceNumber,
      notes: invoice.notes,
      deliveryFee: invoice.deliveryFee,
      haulAway: invoice.haulAway,
      walkUp: invoice.walkUp,
      walkUpFee: walkFee,
      subTotal: invoice.subTotal,
      total: invoice.total,
      type: invoice.type,
      salesTax: invoice.salesTax,
      items: invoice.items,
      status: invoice.status,
      billTo: invoice.billTo || invoice.client,
      shipTo: invoice.shipTo || invoice.client,
      contact: locationContacts.length ? locationContacts : invoice.contact,
      totalAmountReceived: totalAmountReceived,
      balanceDue: calculateBalance(total, totalAmountReceived),
      link: `${process.env.REACT_APP_URL}/invoice/${invoice._id}`,
      paymentRecords: invoice.paymentRecords,
      logoUrl: invoice?.logoUrl || company?.logo,
    }
    const basePayload = {
      invoiceId: invoice._id,
      userId: authData?.result?._id || authData?.result?.googleId,
      userEmail: authData?.result?.email,
      bccList: warehouseEmailList,
      email: invoice.client?.email,
      invoiceNumber: invoice.invoiceNumber,
      clientPONumber: invoice.clientPONumber,
      ...customerInvoicePayload,
      shipTo: invoice.shipTo || invoice.client,
      billTo: invoice.billTo || invoice.client,
      items: (invoice.items || []).map((it, idx) => ({
        ...it,
        podStatus: podItemStatuses[idx] || 'COMPLETE',
      })),
      photos: hasPdf ? [] : podPhotos,
      signature: hasPdf ? null : podSignature,
      damageAcknowledged: hasPdf ? '' : podDamage,
      acknowledgedBy: hasPdf ? '' : acknowledgedName,
      contactName: hasPdf ? '' : acknowledgedName,
      contactPhone: hasPdf ? '' : (locationContacts?.[0]?.phone || contact?.phone || ''),
      contactEmail: hasPdf ? '' : (locationContacts?.[0]?.email || contact?.email || ''),
      haulAway: invoice.haulAway,
      walkUp: invoice.walkUp,
      walkUpFee: walkFee,
      contacts: hasPdf ? [] : locationContacts,
      pdfAttachment: hasPdf ? { filename: podPdfFile?.name, content: podPdfFile?.dataUrl } : null,
      invoice: customerInvoicePayload,
      includeInvoice: true,
    }
    const payload = {
      ...basePayload,
    }
    // If POD already exists, reuse; otherwise generate or use uploaded PDF
    if (hasPodLink) {
      payload.reuseExistingPod = true
      payload.proofOfDeliveryUrl = currentPodUrl
      payload.proofOfDeliveryFileId = currentPodFileId
    }
    axios.post(`${process.env.REACT_APP_API}/pdfs/send-pod`, payload)
      .then((resp) => {
        const data = resp?.data || {};
        if (data.proofOfDeliveryUrl || data.proofOfDeliveryFileId) {
          setInvoiceData((prev) => ({
            ...prev,
            proofOfDeliveryUrl: data.proofOfDeliveryUrl || prev.proofOfDeliveryUrl,
            proofOfDeliveryFileId: data.proofOfDeliveryFileId || prev.proofOfDeliveryFileId,
          }));
        }
        setPodBothStatus('success')
      })
      .catch((err) => {
        console.error(err)
        setPodBothStatus('error')
      })
  }


const iconSize = {height: '18px', width: '18px', marginRight: '10px', color: 'gray'}
const [open, setOpen ] = useState(false)

  const handleUpdatePaymentRecord = async (updatedRecord) => {
    const currentInvoiceId = invoiceData?._id || invoice?._id;
    if (!currentInvoiceId) return;

    const sourceInvoice = invoiceData?._id ? invoiceData : invoice;
    const existingRecords = sourceInvoice?.paymentRecords || [];
    const nextRecords = existingRecords.map((record) =>
      record._id === updatedRecord._id ? { ...record, ...updatedRecord } : record
    );

    const totalAmountReceivedCalc = nextRecords.reduce(
      (sum, rec) => sum + Number(rec?.amountPaid || 0),
      0
    );
    const invoiceTotal = Number(sourceInvoice?.total || 0);
    const nextStatus =
      totalAmountReceivedCalc >= invoiceTotal
        ? "Paid"
        : totalAmountReceivedCalc > 0
        ? "Partial"
        : "Unpaid";

    const payload = {
      ...sourceInvoice,
      paymentRecords: nextRecords,
      totalAmountReceived: totalAmountReceivedCalc,
      status: nextStatus,
    };

    try {
      await dispatch(updateInvoice(currentInvoiceId, payload));
      setInvoiceData(payload);
      dispatch(getInvoice(currentInvoiceId));
      openSnackbar("Payment record updated");
    } catch (error) {
      console.error(error);
      openSnackbar("Unable to update payment");
    }
  };

  const sendHistoryEntries = React.useMemo(() => {
    const entries = Array.isArray(invoice?.sendHistory) ? [...invoice.sendHistory] : []
    return entries.sort((a, b) => new Date(b.sentAt || 0) - new Date(a.sentAt || 0))
  }, [invoice])

  const sendLabel = (eventType) => {
    if (eventType === 'customer_pdf') return 'Sent to Customer'
    if (eventType === 'pc_pdf') return 'Sent to PC'
    if (eventType === 'proof_of_delivery') return 'Proof of Delivery Sent'
    return 'Sent'
  }


  function checkStatus() {
    return totalAmountReceived >= total ? "green"
         : status === "Partial" ? "#1976d2"
         : status === "Paid" ? "green"
         : status === "Unpaid" ? "red"
         : "red";
}

  const totals = React.useMemo(() => {
    const items = invoiceData?.items?.length ? invoiceData.items : invoice?.items || []
    return totalsReducer(items, deliveryFee ?? invoice?.deliveryFee ?? 0, haulAway, walkUp, invoice?.walkUp)
  }, [invoiceData?.items, invoice?.items, deliveryFee, haulAway, walkUp, invoice?.walkUp])


if(!invoice) {
  return (
    <Spinner />
  )
}

    return (
      <>
        <div className={styles.PageLayout}>
            <div className={styles.buttons}>
                  <ProgressButton 
                    onClick={sendPdf} 
                    state={sendStatus}
                    onSuccess={()=> openSnackbar("Invoice sent successfully")}
              >
              Send to Customer
              </ProgressButton>

              <ProgressButton 
                onClick={sendPcPdf} 
                state={sendPcStatus}
                onSuccess={()=> openSnackbar("PC invoice sent successfully")}
              >
              Send to PC
              </ProgressButton>
          
                <ProgressButton 
                  onClick={createAndDownloadPdf} 
                  state={downloadStatus}>
                  Download PDF
                </ProgressButton>

                <button 
                className={styles.btn}  
                onClick={() => editInvoice(invoiceData._id)}
                > 
                <BorderColorIcon style={iconSize} 
                />
                Edit Invoice
                </button>

                <button 
                  // disabled={status === 'Paid' ? true : false}
                  className={styles.btn} 
                  onClick={() => setOpen((prev) => !prev)}> 
                  <MonetizationOnIcon style={iconSize} 
                /> 
                Record Payment
                </button>
            </div>

            <div className={styles.historySection}>
              {sendHistoryEntries.length > 0 && (
                <div style={{ marginTop: 16, marginBottom: 8, border: '1px solid #e5e7eb', borderRadius: 8, padding: 12 }}>
                  <Typography variant="subtitle1" gutterBottom>Send History</Typography>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    {sendHistoryEntries.map((entry, idx) => (
                      <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                        <div style={{ fontWeight: 600 }}>{sendLabel(entry.eventType)}</div>
                        <div style={{ color: '#4b5563', fontSize: 14 }}>
                          {entry.userEmail || 'Unknown user'} • {entry.sentAt ? moment(entry.sentAt).format('MMM D, YYYY h:mm A') : '—'}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

            </div>
              {invoice?.paymentRecords?.length !== 0 && (
                <PaymentHistory
                  paymentRecords={invoiceData?.paymentRecords}
                  allowEditing
                  onUpdatePayment={handleUpdatePaymentRecord}
                />
              )}
            <Modal open={open} setOpen={setOpen} invoice={invoice}/>
            <div className={styles.invoiceLayout}>
        <Container  className={classes.headerContainer}>
        
            <Grid container justifyContent="space-between" style={{padding: '30px 0px' }}>
            {!invoice?.creator?.includes(authData?.result?._id || authData?.result?.googleId) ? 
            (
              <Grid item>
              </Grid>
            )
            : (
                <Grid item onClick={() => history.push('/settings')} style={{cursor: 'pointer'}}>
                    {company?.logo ? <img src={company?.logo} alt="Logo" className={styles.logo} /> 
                    :
                    <h2>Wholesale USA</h2>
                    }
                </Grid>
            )}
                <Grid item style={{marginRight: 40, textAlign: 'right'}}>
                    <Typography style={{lineSpacing: 1, fontSize: 45, fontWeight: 700, color: 'gray'}} >{Number(total - totalAmountReceived) <= 0 ? 'Receipt' : type}</Typography>
                    <Typography variant="overline" style={{color: 'gray'}} >Invoice #</Typography>
                    <Typography variant="body2" gutterBottom>{invoiceData?.invoiceNumber || invoice?.invoiceNumber}</Typography>
                    <Grid container spacing={2} style={{ marginTop: 4, marginBottom: 8 }}>
                      <Grid item xs={12} md={5} style={{ minWidth: 160 }}>
                        <Typography variant="overline" style={{color: 'gray'}} >PC Invoice #</Typography>
                        <Typography variant="body2" noWrap style={{ whiteSpace: 'normal' }}>
                          {invoiceData?.pcInvoiceNumber || invoice?.pcInvoiceNumber || '—'}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={5} style={{ minWidth: 160 }}>
                        <Typography variant="overline" style={{color: 'gray'}} >Client PO #</Typography>
                        <Typography variant="body2" noWrap style={{ whiteSpace: 'normal' }}>
                          {invoiceData?.clientPONumber || invoice?.clientPONumber || '—'}
                        </Typography>
                      </Grid>
                    </Grid>
                </Grid>
            </Grid >
        </Container>
        <Divider />
        <Container>
            <Grid container spacing={3} alignItems="flex-start" justifyContent="space-between" wrap={isMobile ? "wrap" : "nowrap"} style={{marginTop: '40px'}} >
                <Grid item xs={12} md={8}>
                    <Container style={{marginBottom: '20px'}}>
                      <Typography variant="overline" style={{color: 'gray'}} gutterBottom>From</Typography>
                      {/* <Typography variant="subtitle2">{invoice?.businessDetails?.data?.data?.businessName}</Typography>
                      <Typography variant="body2">{invoice?.businessDetails?.data?.data?.email}</Typography>
                      <Typography variant="body2">{invoice?.businessDetails?.data?.data?.phoneNumber}</Typography>
                      <Typography variant="body2" gutterBottom>{invoice?.businessDetails?.data?.data?.address}</Typography> */}
                      <Typography variant="subtitle2">Wholesale USA</Typography>
                      <Typography variant="body2">wholesaleusa@gmail.com</Typography>
                      <Typography variant="body2">(516) 799-6404</Typography>
                    </Container>
                    <Container>
                        <Typography variant="overline" style={{color: 'gray', paddingRight: '3px'}} gutterBottom>Bill to</Typography>
                        <Typography variant="subtitle2" gutterBottom>{billTo?.name || billTo?.store}</Typography>
                        <Typography variant="body2" >{billTo?.email}</Typography>
                        <Typography variant="body2" >{billTo?.phone || billTo?.cellPhone}</Typography>
                        <Typography variant="body2">{billTo?.billingAddress || billTo?.address}</Typography>
                        <Typography variant="body2">{[billTo?.billingCity, billTo?.billingState, billTo?.billingZip].filter(Boolean).join(', ')}</Typography>
                    </Container>
                    <Container style={{marginTop: '12px'}}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} style={{width: '100%'}}>
                                <Typography variant="overline" style={{color: 'gray'}} gutterBottom>Ship to</Typography>
                                {shipTo ? (
                                  <>
                                    <Typography variant="subtitle2" gutterBottom>{shipTo?.name}</Typography>
                                    <Typography variant="body2">{shipTo?.shippingAddress}</Typography>
                                    <Typography variant="body2">
                                      {[shipTo?.shippingCity, shipTo?.shippingState, shipTo?.shippingZip].filter(Boolean).join(', ')}
                                    </Typography>
                                    {shipTo?.phone && (
                                      <Typography variant="body2">{shipTo.phone}</Typography>
                                    )}
                                  </>
                                ) : (
                                  <Typography variant="body2" color="textSecondary">No ship to selected</Typography>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={6} style={{ width: '100%' }}>
                                <Typography variant="overline" style={{color: 'gray'}} gutterBottom>Contact</Typography>
                                {(() => {
                                  const contactList = locationContacts.length
                                    ? locationContacts
                                    : Array.isArray(contact)
                                    ? contact
                                    : contact
                                    ? [contact]
                                    : [];
                                  if (!contactList.length) {
                                    return <Typography variant="body2" color="textSecondary">No contact selected</Typography>;
                                  }
                                  return contactList.map((c) => (
                                    <div key={c?._id || c?.name} style={{ marginBottom: 4 }}>
                                      <Typography variant="subtitle2" gutterBottom>
                                        {c?.name} {c?.primary ? '• Primary' : ''}
                                      </Typography>
                                      <Typography variant="body2">
                                        {[c?.phone || c?.cellPhone].filter(Boolean).join(' ')}
                                      </Typography>
                                    </div>
                                  ));
                                })()}
                            </Grid>
                        </Grid>
                    </Container>
                </Grid>

                <Grid item xs={12} md={4} style={{textAlign: 'right', minWidth: 240}}>
                    <Typography variant="overline" style={{color: 'gray'}} gutterBottom>Status</Typography>
                    <Typography variant="h6" gutterBottom style={{color: checkStatus()}}>{totalAmountReceived >= total ? 'Paid':status}</Typography>
                    <Typography variant="overline" style={{color: 'gray'}} gutterBottom>Date</Typography>
                    <Typography variant="body2" gutterBottom>{moment(invoice.receivedByDate).format("MMM Do YYYY")}</Typography>
                    <Typography variant="overline" style={{color: 'gray'}} gutterBottom>Due Date</Typography>
                    <Typography variant="body2" gutterBottom>{selectedDate? moment(selectedDate).format("MMM Do YYYY") : '27th Sep 2021'}</Typography>
                    <Typography variant="overline" gutterBottom>Amount</Typography>
                    <Typography variant="h6" gutterBottom>
                      ${formatCurrency(getDisplayTotal(invoiceData, invoice, total))}
                    </Typography>
                </Grid>
            </Grid>
        </Container>

        <form>
            <div className={styles.tableWrapper}>
              <TableContainer component={Paper} className={`tb-container ${styles.tableContainer}`}>
                <Table className={classes.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Item</TableCell>
                      <TableCell >Qty</TableCell>
                      {/* <TableCell >#</TableCell> */}
                      <TableCell >Cost</TableCell>
                      <TableCell>Price</TableCell>
                      {/* <TableCell >Disc(%)</TableCell> */}
                      <TableCell >Amount</TableCell>
                      {/* <TableCell >Inv.</TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invoiceData?.items?.map((itemField, index) => {
                      const unitCost = parseFloat(itemField?.unitCost) || 0;
                      const unitPrice = parseFloat(itemField?.unitPrice) || 0;
                      const costHigherThanPrice = unitCost > unitPrice;
                      return (
                      // <TableRow key={index} style={{backgroundColor: itemField?.unitCost > itemField.unitPrice ? "salmon" : ''}}>
                      <TableRow key={index} style={costHigherThanPrice ? { backgroundColor: "rgba(239, 68, 68, 0.15)" } : undefined}>
                        <TableCell scope="row" style={{width: '40%' }}> <InputBase style={{width: '100%'}} outline="none" sx={{ ml: 1, flex: 1 }} type="text" name="modelNumber" value={itemField.modelNumber} placeholder="Item name or description" readOnly /> </TableCell>
                        <TableCell align="right"> <InputBase sx={{ ml: 1, flex: 1 }} type="number" name="quantity" value={itemField?.quantity} placeholder="0" readOnly /> </TableCell>
                        {/* <TableCell align="right">
                          <FormGroup sx={{ ml: 1, flex: 1 }}>
                                  <FormControlLabel control={
                                    <Checkbox
                                      name="lockup"
                                        color="primary"
                                        checked={itemField?.lockup}
                                        disabled
                                    />} label="" />
                                </FormGroup>
                        </TableCell> */}
                        <TableCell align="right"> <InputBase sx={{ ml: 1, flex: 1 }} type="number" name="unitCost" value={itemField?.unitCost} placeholder="0" readOnly /> </TableCell>
                        <TableCell align="right"> <InputBase sx={{ ml: 1, flex: 1 }} type="number" name="unitPrice" value={itemField?.unitPrice} placeholder="0" readOnly /> </TableCell>
                        {/* <TableCell align="right"> <InputBase sx={{ ml: 1, flex: 1 }} type="number" name="discount"  value={itemField?.discount} readOnly /> </TableCell> */}
                        <TableCell align="right"> <InputBase sx={{ ml: 1, flex: 1 }} type="number" name="amount"  value={((itemField?.quantity * itemField.unitPrice) - (itemField.quantity * itemField.unitPrice) * itemField.discount / 100).toFixed(2)} readOnly /> </TableCell>
                        {/* <TableCell align="right">
                          <FormGroup sx={{ ml: 1, flex: 1 }}>
                                  <FormControlLabel control={
                                    <Checkbox
                                      name="doNotOrder"
                                        color="primary"
                                        checked={itemField?.doNotOrder}
                                        disabled
                                    />} label="" />
                                </FormGroup>
                        </TableCell> */}
                      </TableRow>
                    );
                  })}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
                
                <div className={styles.summaryRow}>
                  <div className={styles.invoiceSummary}>
                    <div className={styles.summary}>Cost & Profit (Fees included)</div>
                    <div className={styles.summaryItem}>
                      <p>Total Cost</p>
                      <h4>${formatCurrency(totals.totalCost)}</h4>
                    </div>
                    <div className={styles.summaryItem}>
                      <p>Total Profit</p>
                      <h4>${formatCurrency(totals.totalProfit)}</h4>
                    </div>
                  </div>
                  <div className={styles.invoiceSummary}>
                    <div className={styles.summary}>Invoice Summary</div>
                    <div className={styles.summaryItem}>
                      <p>Delivery Fee:</p>
                      <h4>${formatCurrency(deliveryFee)}</h4>
                    </div>
                    {haulAway && (
                      <div className={styles.summaryItem}>
                        <p>Haul Away:</p>
                        <h4>$40.00</h4>
                      </div>
                    )}
                    {walkUp && (
                      <div className={styles.summaryItem}>
                        <p>Walk Up ({walkUp}):</p>
                        <h4>${getWalkUpFee(walkUp).toFixed(2)}</h4>
                      </div>
                    )}
                    <div className={styles.summaryItem}>
                        <p>Subtotal:</p>
                        <h4>${formatCurrency(subTotal)}</h4>
                    </div>
                    <div className={styles.summaryItem}>
                        <p>{`Sales Tax(${rates}%):`}</p>
                        <h4>${formatCurrency(salesTax)}</h4>
                    </div>
                    {(() => {
                      const numericTotal = Number(total || invoice?.total || 0);
                      const numericPaid = Number(totalAmountReceived || 0);
                      const balance = calculateBalance(numericTotal, numericPaid);
                      return (
                        <>
                          <div className={styles.summaryItem}>
                              <p>Total</p>
                              <h4>${formatCurrency(numericTotal)}</h4>
                          </div>
                          <div className={styles.summaryItem}>
                              <p>Paid</p>
                              <h4>${formatCurrency(numericPaid)}</h4>
                          </div>

                          <div className={styles.summaryItem}>
                            <p>Balance</p>
                            <h4 style={{color: "black", fontSize: "18px", lineHeight: "8px"}}>${formatCurrency(balance)}</h4>
                          </div>
                        </>
                      );
                    })()}
                  </div>
                </div>

                <div className={styles.note}>
                    <h4 style={{marginLeft: '-10px'}}>Note/Payment Info</h4>
                    <p style={{fontSize: '14px'}}>{invoiceData.notes}</p>
                </div>

            {/* <button className={styles.submitButton} type="submit">Save and continue</button> */}
        </form>
    </div>
        </div>
        {/* Proof of Delivery Section below invoice details */}
        <Container maxWidth="md" style={{ marginTop: 32, padding: 16, border: '1px solid #e5e7eb', borderRadius: 8, boxSizing: 'border-box' }}>
          <Typography variant="h6" gutterBottom>Proof of Delivery</Typography>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
            <Typography variant="body2" color={hasPodLink ? 'primary' : 'textSecondary'}>
              {podStatusLabel}
            </Typography>
            {hasPodLink && currentPodUrl && (
              <Button
                size="small"
                component="a"
                href={currentPodUrl}
                target="_blank"
                rel="noreferrer"
                variant="text"
              >
                View POD
              </Button>
            )}
          </div>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>Upload PDF</Typography>
              <input type="file" accept="application/pdf" style={{ display: 'none' }} ref={podPdfInputRef} onChange={handlePodPdfUpload} />
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => podPdfInputRef.current?.click()}
                  disabled={Boolean(podPhotos.length || podSignature || podDamage !== 'No' || podAcknowledgedBy || (podItemStatuses || []).some((s) => s && s !== 'COMPLETE'))}
                >
                  {podPdfFile ? 'Replace PDF' : 'Choose PDF'}
                </Button>
                {podPdfFile && (
                  <>
                    <Typography variant="caption" color="textSecondary">{podPdfFile.name}</Typography>
                    <Button size="small" onClick={removePodPdf}>Remove</Button>
                    <Button size="small" onClick={() => setPodPreviewOpen(true)}>Preview</Button>
                  </>
                )}
              </div>
            </Grid>
            <Grid item xs={12}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                <div style={{ flex: 1, height: 1, background: '#e5e7eb' }} />
                <Typography variant="caption" color="textSecondary">OR</Typography>
                <div style={{ flex: 1, height: 1, background: '#e5e7eb' }} />
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" gutterBottom>Delivery Photos</Typography>
              <input
                ref={podPhotoInputRef}
                type="file"
                accept="image/*"
                multiple
                onChange={handlePodPhotoUpload}
                style={{ display: 'none' }}
                disabled={Boolean(podPdfFile)}
              />
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <Button variant="outlined" size="small" onClick={() => podPhotoInputRef.current?.click()} disabled={Boolean(podPdfFile)}>
                  Choose Files
                </Button>
                <Typography variant="caption" color="textSecondary">
                  {podPhotos.length} file(s) selected
                </Typography>
              </div>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
                {podPhotos.map((src, idx) => (
                  <div key={idx} style={{ position: 'relative' }}>
                    <img
                      src={src}
                      alt="Delivery"
                      style={{ width: 120, height: 'auto', borderRadius: 6, border: '1px solid #e5e7eb' }}
                    />
                    <button
                      type="button"
                      onClick={() => handleRemovePodPhoto(idx)}
                      style={{
                        position: 'absolute',
                        top: -6,
                        right: -6,
                        background: '#fff',
                        border: '1px solid #ccc',
                        borderRadius: '50%',
                        width: 20,
                        height: 20,
                        cursor: 'pointer',
                        fontSize: 12,
                        lineHeight: '18px',
                        padding: 0,
                      }}
                      aria-label="Remove photo"
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" gutterBottom>Signature Image</Typography>
              <input type="file" accept="image/*" onChange={handlePodSignatureUpload} disabled={Boolean(podPdfFile)} />
              {podSignature && (
                <div style={{ marginTop: 8 }}>
                  <img src={podSignature} alt="Signature" style={{ maxWidth: 240, height: 'auto', borderRadius: 6, border: '1px solid #e5e7eb' }} />
                </div>
              )}
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>Line Item Status</Typography>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 8 }}>
                {(invoice.items || []).map((item, idx) => (
                  <div key={idx} style={{ border: '1px solid #e5e7eb', borderRadius: 6, padding: 8 }}>
                    <Typography variant="body2" style={{ fontWeight: 600 }}>{item.modelNumber || 'Item'}</Typography>
                    <Typography variant="caption" color="textSecondary">Qty: {item.quantity}</Typography>
                    <div style={{ marginTop: 6 }}>
                      <label style={{ fontSize: 12, marginRight: 6 }}>Status:</label>
                      <select
                        value={podItemStatuses[idx] || 'COMPLETE'}
                        onChange={(e) => handlePodItemStatusChange(idx, e.target.value)}
                        disabled={Boolean(podPdfFile)}
                        style={{ padding: '4px 6px', fontSize: 12 }}
                      >
                        <option value="COMPLETE">Complete</option>
                        <option value="REJECTED">Rejected</option>
                      </select>
                    </div>
                  </div>
                ))}
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={podDamage === 'Yes'}
                      onChange={(e) => setPodDamage(e.target.checked ? 'Yes' : 'No')}
                      disabled={Boolean(podPdfFile)}
                    />
                  }
                  label="Any existing damage?"
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Acknowledged by"
                value={podAcknowledgedBy}
                onChange={(e) => setPodAcknowledgedBy(e.target.value)}
                disabled={Boolean(podPdfFile)}
                placeholder={locationContacts.find((c) => c.primary)?.name || locationContacts?.[0]?.name || contact?.name || ''}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={sendProofOfDelivery}
                disabled={podStatus === 'loading'}
              >
                {podStatus === 'loading' ? 'Sending...' : 'Send Proof of Delivery'}
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={sendProofOfDeliveryAndInvoice}
                disabled={podBothStatus === 'loading'}
                style={{ marginLeft: 8 }}
              >
                {podBothStatus === 'loading' ? 'Sending...' : 'Send both'}
              </Button>
              {hasPodLink && (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={resendProofOfDelivery}
                  disabled={podResendStatus === 'loading'}
                  style={{ marginLeft: 8 }}
                >
                  {podResendStatus === 'loading' ? 'Resending...' : 'Resend POD'}
                </Button>
              )}
              {podStatus === 'success' && (
                <Typography variant="caption" style={{ marginLeft: 12, color: 'green' }}>
                  Sent successfully
                </Typography>
              )}
              {podStatus === 'error' && (
                <Typography variant="caption" style={{ marginLeft: 12, color: 'red' }}>
                  Failed to send
                </Typography>
              )}
              {podBothStatus === 'success' && (
                <Typography variant="caption" style={{ marginLeft: 12, color: 'green' }}>
                  Sent both successfully
                </Typography>
              )}
              {podBothStatus === 'error' && (
                <Typography variant="caption" style={{ marginLeft: 12, color: 'red' }}>
                  Failed to send both
                </Typography>
              )}
              {podResendStatus === 'success' && (
                <Typography variant="caption" style={{ marginLeft: 12, color: 'green' }}>
                  Resent successfully
                </Typography>
              )}
              {podResendStatus === 'error' && (
                <Typography variant="caption" style={{ marginLeft: 12, color: 'red' }}>
                  Failed to resend
                </Typography>
              )}
            </Grid>
          </Grid>
        </Container>
        <Dialog open={podPreviewOpen} onClose={() => setPodPreviewOpen(false)} maxWidth="md" fullWidth>
          <DialogTitle>{podPdfFile?.name || 'PDF Preview'}</DialogTitle>
          <DialogContent dividers>
            {podPdfFile?.dataUrl ? (
              <object
                data={podPdfFile.dataUrl}
                type="application/pdf"
                width="100%"
                height="600px"
                style={{ border: '1px solid #e5e7eb', borderRadius: 4 }}
              >
                <Typography variant="body2">Preview not available.</Typography>
              </object>
            ) : (
              <Typography variant="body2">No PDF selected.</Typography>
            )}
          </DialogContent>
        </Dialog>
      </>
    )
}

export default InvoiceDetails
